import { MortgagePageEnum } from '@app/sign-up/enums/mortgage-page.enum';
import { PropertyPageEnum } from '@app/sign-up/enums/property-page.enum';
import { SmartSearchPageEnum } from '@app/sign-up/enums/smart-search-page.enum';
import { FlowStepsModel } from '@app/sign-up/models/flow-steps.model';
import { paths } from '@platform/paths';

export const REMORTGAGE_NOW_FLOW = {
  PropertyAddress: 0,
  PropertyOverview: 1,
  PropertyAdditionalInfo: 2,
  MortgageLender: 3,
  MortgageRateAndPeriod: 4,
  MortgageBorrowedAmountAndTerm: 5,
  MortgageMonthlyPayment: 6,
  MortgageProductMatch: 7,
  SmartSearchLiveResults: 8,
  UserCreate: 9,
} as const;

export const REMORTGAGE_NOW_FLOW_STEPS: FlowStepsModel<typeof REMORTGAGE_NOW_FLOW> = {
  [REMORTGAGE_NOW_FLOW.PropertyAddress]: {
    step: REMORTGAGE_NOW_FLOW.PropertyAddress,
    name: 'PropertyAddress',
    page: {
      route: paths.signUp.Property,
      name: PropertyPageEnum.Address,
    },
  },
  [REMORTGAGE_NOW_FLOW.PropertyAdditionalInfo]: {
    step: REMORTGAGE_NOW_FLOW.PropertyAdditionalInfo,
    name: 'PropertyAdditionalInfo',
    page: {
      route: paths.signUp.Property,
      name: PropertyPageEnum.AdditionalInfo,
    },
  },
  [REMORTGAGE_NOW_FLOW.PropertyOverview]: {
    step: REMORTGAGE_NOW_FLOW.PropertyOverview,
    name: 'PropertyOverview',
    page: {
      route: paths.signUp.Property,
      name: PropertyPageEnum.Overview,
    },
  },
  [REMORTGAGE_NOW_FLOW.MortgageLender]: {
    step: REMORTGAGE_NOW_FLOW.MortgageLender,
    name: 'MortgageLender',
    page: {
      route: paths.signUp.Mortgage,
      name: MortgagePageEnum.Lender,
    },
  },
  [REMORTGAGE_NOW_FLOW.MortgageRateAndPeriod]: {
    step: REMORTGAGE_NOW_FLOW.MortgageRateAndPeriod,
    name: 'MortgageRateAndPeriod',
    page: {
      route: paths.signUp.Mortgage,
      name: MortgagePageEnum.RateAndPeriod,
    },
  },
  [REMORTGAGE_NOW_FLOW.MortgageBorrowedAmountAndTerm]: {
    step: REMORTGAGE_NOW_FLOW.MortgageBorrowedAmountAndTerm,
    name: 'MortgageBorrowedAmountAndTerm',
    page: {
      route: paths.signUp.Mortgage,
      name: MortgagePageEnum.BorrowedAmountAndTerm,
    },
  },
  [REMORTGAGE_NOW_FLOW.MortgageMonthlyPayment]: {
    step: REMORTGAGE_NOW_FLOW.MortgageMonthlyPayment,
    name: 'MortgageMonthlyPayment',
    page: {
      route: paths.signUp.Mortgage,
      name: MortgagePageEnum.MonthlyPayment,
    },
  },
  [REMORTGAGE_NOW_FLOW.MortgageProductMatch]: {
    step: REMORTGAGE_NOW_FLOW.MortgageProductMatch,
    name: 'MortgageProductMatch',
    page: {
      route: paths.signUp.Mortgage,
      name: MortgagePageEnum.ProductMatch,
    },
  },
  [REMORTGAGE_NOW_FLOW.SmartSearchLiveResults]: {
    step: REMORTGAGE_NOW_FLOW.SmartSearchLiveResults,
    name: 'SmartSearchLiveResults',
    page: {
      route: paths.signUp.SmartSearch,
      name: SmartSearchPageEnum.LiveResults,
    },
  },
  [REMORTGAGE_NOW_FLOW.UserCreate]: {
    step: REMORTGAGE_NOW_FLOW.UserCreate,
    name: 'UserCreate',
    page: {
      route: paths.signUp.User,
      name: 'UserCreate',
    },
  },
};
